import { createRootRoute, Outlet, ScrollRestoration } from "@tanstack/react-router";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { ErrorBoundary } from "@/components/shared/ErrorBoundary";
import { StagingGate } from "@/components/shared/StagingGate";
import { IS_SPLASH_MODE } from "@/lib/siteMode";

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  return (
    <StagingGate>
    <div className="min-h-screen flex flex-col">
      {/* Accessibility: skip to main content link */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-qds-primary focus:text-qds-text-inverse focus:px-4 focus:py-2 focus:rounded-lg focus:text-sm focus:font-medium"
      >
        Skip to main content
      </a>

      {IS_SPLASH_MODE ? null : <Header />}
      <main id="main-content" className="flex-1" role="main">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      {IS_SPLASH_MODE ? null : <Footer />}
      <ScrollRestoration />
    </div>
    </StagingGate>
  );
}
